import { formatFileSize } from '../../utils/format-utils'

/**
 * Yüklemeden önce dosyaları doğrular
 */
export const validateFiles = (
    files,
    maxTotalSize = 15 * 1024 * 1024,
    maxSingleFileSize = 15 * 1024 * 1024,
    maxImageSize = 5 * 1024 * 1024,
    allowedTypes = getDefaultAllowedTypes(),
) => {
  // Giriş doğrulama
  if (!isValidInput(files)) {
    return {
      valid: false,
      errors: ['Doğrulanacak dosya yok'],
      filesToProcess: [],
    }
  }

  const result = processFiles(files, maxSingleFileSize, maxImageSize, allowedTypes)

  // Toplam boyut kontrolü
  if (result.totalSize > maxTotalSize) {
    result.errors.push(`Toplam dosya boyutu (${formatFileSize(result.totalSize)}) limiti aşıyor: ${formatFileSize(maxTotalSize)}`)
    return {
      valid: false,
      errors: result.errors,
      filesToProcess: [],
    }
  }

  return {
    valid: result.filesToProcess.length > 0,
    errors: result.errors,
    filesToProcess: result.filesToProcess,
    totalSize: result.totalSize,
  }
}

/**
 * Varsayılan izin verilen MIME türlerini döndürür
 */
function getDefaultAllowedTypes() {
  return [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
    'application/rtf',
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ]
}

/**
 * Geçerli bir dosya dizisi olup olmadığını kontrol eder
 */
function isValidInput(files) {
  return files && Array.isArray(files) && files.length > 0
}

/**
 * Dosyaları işler ve doğrular
 */
function processFiles(files, maxSingleFileSize, maxImageSize, allowedTypes) {
  const errors = []
  const filesToProcess = []
  let totalSize = 0

  files.forEach(file => {
    const validationResult = validateSingleFile(file, maxSingleFileSize, maxImageSize, allowedTypes)

    if (validationResult.valid) {
      filesToProcess.push(file)
      totalSize += file.size
    } else {
      errors.push(validationResult.error)
    }
  })

  return {
    errors,
    filesToProcess,
    totalSize,
  }
}

/**
 * Tek bir dosyayı doğrular
 */
function validateSingleFile(file, maxSingleFileSize, maxImageSize, allowedTypes) {
  // Temel doğrulama
  if (!file || typeof file !== 'object') {
    return { valid: false, error: 'Geçersiz dosya nesnesi' }
  }

  // Dosya boyutu doğrulama
  if (!file.size) {
    return { valid: false, error: `Dosya boyutu belirlenemiyor: ${file.name}` }
  }

  // Dosya türünü kontrol et
  if (!file.type || !allowedTypes.includes(file.type)) {
    return { valid: false, error: `Desteklenmeyen dosya türü: ${file.name} (${file.type || 'bilinmiyor'})` }
  }

  // Dosya türüne göre boyut limitleri
  if (file.type.startsWith('image/')) {
    if (file.size > maxImageSize) {
      return { valid: false, error: `Görsel çok büyük: ${file.name} (${formatFileSize(file.size)}), maksimum ${formatFileSize(maxImageSize)}` }
    }
  } else if (file.size > maxSingleFileSize) {
    return { valid: false, error: `Dosya çok büyük: ${file.name} (${formatFileSize(file.size)}), maksimum ${formatFileSize(maxSingleFileSize)}` }
  }

  return { valid: true }
}